import { queryAll, query, fromId } from '../utils/utils.js';

export class AnchorNav {
    root = query('body');
	fillerDiv = null;
	lastScrollTop = 0;

    constructor() {
		
		//remove items from the anchor nav that don't match to any anchor (conditional)
		let hasRemovedItems = false;
		let items = this.root.querySelectorAll('.anchor-nav .nav-item');
		items.forEach((item) => {
			if(query(item.querySelector('a').getAttribute('href')) === null) {
				item.remove();
				hasRemovedItems = true;
			}
		});

		if (hasRemovedItems) console.log( '[bhs] ⚠️ removed items from anchor nav - check that there’s a matched anchor assigned to a section.' );

		let interiorNavs = this.root.querySelectorAll('.interior-nav-block');
		interiorNavs.forEach((item) => {
			if(item.classList.contains("variation-scrollable")){
				//item.querySelector('.anchor-background').style.top = item.querySelector('.interior-nav').getBoundingClientRect().height+"px";
			}
		});

		// build mobile views // 	
		queryAll('.interior-nav-block').forEach(( intNavBlockSection ) => {
			
			if( !intNavBlockSection.classList.contains('has-hero') ) {
				this.createScrollSpy( intNavBlockSection );
				// create mobile view w/ content accordion //
				this.createMobileView( intNavBlockSection );
			} else {
				this.createMobileListView(intNavBlockSection);
				this.createScrollSpy(intNavBlockSection);
			}

			if( intNavBlockSection.classList.contains('is-sticky') ) {
				this.handleStickyNav( intNavBlockSection );
			}
		});
		
	}

	createScrollSpy( section ) {
		
		const interiorContent = section.querySelector('.interior-nav-content');
		const items = section.querySelectorAll('.anchor-nav .nav-item a');
		const isInteriorScrollable = section.classList.contains('variation-scrollable');

		interiorContent.items = [];

		items.forEach((item) => {
			const intNavGroup = section.querySelector('.interior-nav-group');
			const intNavFixedContainer = section.querySelector('.interior-nav-fixed-container');
			const anchor = item.getAttribute('href');
			const contentDIV =	section.querySelector(anchor);


			if ( contentDIV ) {
				item.contentDiv = contentDIV;
				contentDIV.navItem = item;
				contentDIV.mobileItem = section.querySelector(`.int-nav-mobile-link-list a[href*=\'${anchor}\']`);
				
				//console.log(contentDIV.mobileItem);
				
				interiorContent.items.push(contentDIV);

				item.addEventListener('click', (e) => {
					e.preventDefault();
					const anchor = document.querySelector(e.currentTarget.getAttribute('href'));
					
					if ( !anchor) return;
					
					let nextScrollDirection = this.lastScrollTop < anchor.offsetTop ? 'down' : 'up';
					let isNavSticky = false;
					let elementY = anchor.offsetTop - 75;
					let topContentY = elementY;
					let hasScrolled = ( intNavGroup.classList.contains('has-scrolled') );
					let isNavMin = (intNavGroup.classList.contains('hidenav') );
					let yOffSet = ((hasScrolled) ? ((nextScrollDirection === 'down') ? -150 : -75) : 75);

					if (intNavGroup) {
						isNavSticky = intNavFixedContainer.classList.contains('is-fixed');
						
						if( intNavGroup.dataset.minHeight ) {
							topContentY = elementY - intNavGroup.dataset.minHeight - yOffSet;
						}
					}
					let anchorTop = null;
					let scrollTo = null;
					if( isInteriorScrollable ) {
						anchorTop = interiorContent.querySelector(e.currentTarget.getAttribute('href')).offsetTop;
						scrollTo = anchorTop;
						interiorContent.scrollTo({ top: scrollTo, behavior: 'smooth' });
					} else {
						window.scrollTo({ top: topContentY, behavior: 'smooth' });
					}
					
				});
			}

		});
		
		if ( isInteriorScrollable ) {
			interiorContent.addEventListener('scroll', (e) => {
				e.currentTarget.items.forEach( ( anchorDiv ) => {
					
					const intTop = e.currentTarget.offsetTop;
					const anchorTop = anchorDiv.offsetTop;
					const anchorBottom = anchorDiv.offsetTop + anchorDiv.offsetHeight;
					const scrollPos = e.currentTarget.scrollTop;
					if (scrollPos >= anchorTop && scrollPos < anchorBottom) {
						anchorDiv.navItem.classList.add('active');
						if (anchorDiv.mobileItem) anchorDiv.mobileItem.classList.add('active');
					} else {
						anchorDiv.navItem.classList.remove('active');
						if (anchorDiv.mobileItem) anchorDiv.mobileItem.classList.remove('active');
					}
				});
			});

			interiorContent.dispatchEvent(new Event('scroll', {
				bubbles: true,
				cancelable: true,
			}));

		} else {
			
			// add scroll event to window for top nav items //
			window.addEventListener('scroll', (e) => {
				const intNavFixedContainer = section.querySelector('.interior-nav-fixed-container');
				const intNavGroup = section.querySelector('.interior-nav-group');
				
				let isNavSticky = false;
				
				if (intNavGroup) isNavSticky = intNavFixedContainer.classList.contains('is-fixed');
				
				interiorContent.items.forEach((anchorDiv) => {
					
					const intTop = e.currentTarget.offsetTop;
					const anchorTop = anchorDiv.offsetTop;
					const anchorBottom = anchorDiv.offsetTop + anchorDiv.offsetHeight;
					const scrollPos = e.currentTarget.scrollY;
					const intNavGroupHeight = intNavGroup.minHeight ? intNavGroup.minHeight : intNavGroup.getBoundingClientRect().height;
					const mobileTrigger = section.querySelector('.anchor-nav-trigger');

					// factor in intNavGroup height to offset the scroll position //
					if( isNavSticky ) {
						if( scrollPos >= anchorTop - intNavGroupHeight && scrollPos < anchorBottom - intNavGroupHeight ) {
							anchorDiv.navItem.classList.add('active');
							if (anchorDiv.mobileItem) anchorDiv.mobileItem.classList.add('active');

							if (mobileTrigger) mobileTrigger.querySelector('.title').innerHTML = anchorDiv.navItem.innerHTML;
						} else {
							anchorDiv.navItem.classList.remove('active');
							if (anchorDiv.mobileItem) anchorDiv.mobileItem.classList.remove('active');
						}
					} else {
						if( scrollPos >= anchorTop && scrollPos < anchorBottom ) {
							anchorDiv.navItem.classList.add('active');
							if( anchorDiv.mobileItem ) anchorDiv.mobileItem.classList.add('active');
							if (mobileTrigger) mobileTrigger.querySelector('.title').innerHTML = anchorDiv.navItem.innerHTML;
						} else {
							anchorDiv.navItem.classList.remove('active');
							if (anchorDiv.mobileItem) anchorDiv.mobileItem.classList.remove('active');
						}
					}

					

				});

				this.lastScrollTop = window.scrollY;
			});

			window.dispatchEvent(new Event('scroll', {
				bubbles: true,
				cancelable: true,
			}));
		}
	}


	createMobileView( section ) {
		
		console.log('[BHS] creating mobile view for anchor nav');

		// Guard against missing elements (can happen if block is disabled/empty)
		const navItems = section.querySelector('nav.nav-items');
		const interiorNavContent = section.querySelector('.interior-nav-content');
		const interiorNavMobile = section.querySelector('.interior-nav-mobile');
		
		if (!navItems || !interiorNavContent || !interiorNavMobile) {
			console.log('[BHS] anchor nav section missing required elements, skipping mobile view');
			return;
		}
		
		navItems.classList.add('d-none', 'd-lg-flex');
		interiorNavContent.classList.add('d-none', 'd-lg-block');
		interiorNavMobile.classList.add('d-lg-none');
		
		section.querySelectorAll('nav.nav-items .nav-item').forEach(( navitem , i ) => {

			let anchor = navitem.querySelector('a');
			let mobileNavItem = document.createElement('div');
			mobileNavItem.classList.add('int-nav-mobile-item');
			
			let mobileNavItemLink = document.createElement('button');
			mobileNavItemLink.classList.add('int-nav-mobile-item-link');
			mobileNavItemLink.innerHTML = anchor.innerHTML;
			mobileNavItemLink.addEventListener('click', (e) => {
				e.preventDefault();
				this.openMobileItem(mobileNavItemLink);
			});

			mobileNavItem.appendChild(mobileNavItemLink);
			
			let plusminusDiv = document.createElement('div');
			plusminusDiv.classList.add('plus-minus');
			let plus = document.createElement('span');
			plus.classList.add('plus');
			plus.innerHTML = '+';
			plusminusDiv.appendChild(plus);
			let minus = document.createElement('span');
			minus.classList.add('minus');
			minus.innerHTML = '–';
			plusminusDiv.appendChild(minus);
			mobileNavItemLink.appendChild(plusminusDiv);

			let mobileNavItemContentContainer = document.createElement('div');
			mobileNavItemContentContainer.classList.add('int-nav-mobile-item-content-container');

			// create mobile nav item content container //
			let mobileNavItemContent = document.createElement('div');
			mobileNavItemContent.classList.add('int-nav-mobile-item-content');
			
			let clonedContent = section.querySelector(anchor.getAttribute('href')).cloneNode(true);
			clonedContent.id = clonedContent.id + '-mobile';
			mobileNavItemContent.appendChild(clonedContent);

			mobileNavItemContentContainer.appendChild(mobileNavItemContent);

			mobileNavItemLink.contentDiv = mobileNavItemContentContainer;
			mobileNavItemLink.parentSection = section;
			mobileNavItemContentContainer.navItem = mobileNavItemLink;

			mobileNavItem.appendChild(mobileNavItemContentContainer);
			section.querySelector('.interior-nav-mobile').appendChild(mobileNavItem);

		} );
	}

	openMobileItem( item ) { 

		item.parentSection.querySelectorAll('.int-nav-mobile-item-link').forEach(( link ) => {
			if(link != item){
				link.classList.remove('active');
				link.contentDiv.classList.remove('active');
			} else {
				link.classList.toggle('active');
				link.contentDiv.classList.toggle('active');
			}
		} );
	}

	handleStickyNav( interiorNavSection ) { 

		const navFixedContainer = interiorNavSection.querySelector('.interior-nav-fixed-container');
		const navGroup = interiorNavSection.querySelector('.interior-nav-group');

		if( interiorNavSection.querySelector('.sticky-filler') ) {
			interiorNavSection.filler = interiorNavSection.querySelector('.sticky-filler');
		}
		
		window.addEventListener('scroll', (e) => { 
			
			if( window.scrollY > interiorNavSection.offsetTop ) {
				navFixedContainer.classList.add('is-fixed');
				if (interiorNavSection.filler) interiorNavSection.filler.style.height = navGroup.getBoundingClientRect().height + "px";
			} else {
				navFixedContainer.classList.remove('is-fixed');
				if (interiorNavSection.filler) interiorNavSection.filler.style.height = "0px";
			}
			
		});

		window.addEventListener('resize', (e) => {
			if (interiorNavSection.filler && navFixedContainer.classList.contains('is-fixed') ) interiorNavSection.filler.style.height = navGroup.getBoundingClientRect().height + "px";
		});

		//const interiornavGroup = query('.interior-nav-block.is-sticky');
		//const interiorNavGroup = interiornavGroup.querySelector('.interior-nav-group');
		
		/*window.addEventListener('scroll', (e) => {
			if( window.scrollY > interiornavGroup.offsetTop ) {

				interiorNavGroup.classList.add('is-fixed');
				if (this.fillerDiv) this.fillerDiv.style.height = interiorNavGroup.getBoundingClientRect().height+"px";
			}
		});*/

	}

	createMobileListView(section) {
		console.log( '[BHS] creating mobile list view for anchor nav' );
		const interiorFixedContainer = section.querySelector('.interior-nav-fixed-container');
		const interiorNav = section.querySelector('.interior-nav');
		const navItems = section.querySelectorAll('nav.nav-items .nav-item');
		const trigger = section.querySelector('button.anchor-nav-trigger');
		const interiorNavMobile = section.querySelector('.interior-nav-mobile');
		const mobileNavContent = section.querySelector('.interior-mobile-nav-content');
		
		const interiorMobileContainer = document.createElement('div');
		interiorMobileContainer.classList.add('int-nav-mobile-container');
		interiorNavMobile.appendChild(interiorMobileContainer);

		if ( navItems.length > 0) {
			if( trigger ) trigger.classList.add('enabled');
			console.log( 'has trigger: ' + trigger );
			const mobileNavList = document.createElement('ul');
			mobileNavList.classList.add('int-nav-mobile-link-list');
			interiorMobileContainer.appendChild(mobileNavList);

			navItems.forEach((navitem, i) => {

				let anchor = navitem.querySelector('a');

				let mobileNavLinkListItem = document.createElement('li');
				mobileNavLinkListItem.classList.add('int-nav-mobile-item-link');

				let mobileNavLink = anchor.cloneNode(true);
				mobileNavLinkListItem.appendChild(mobileNavLink);
				mobileNavLink.addEventListener('click', (e) => {
					if (interiorNavMobile) {
						if (trigger) trigger.classList.remove('active');
						interiorNavMobile.style.height = "0px";
					}
				});

				mobileNavList.appendChild(mobileNavLinkListItem);
			});

			// move interiorMobileContainer out of the nav group //
			interiorFixedContainer.appendChild(interiorNavMobile);
		} else {
			// check if mobileNavContent has content //
			if ( mobileNavContent.innerHTML.trim() !== '' ) {
				if( trigger ){
					trigger.classList.add("enabled");
					trigger.querySelector('.title').innerHTML = "More";
				}

				// move interiorMobileContainer out of the nav group //
				interiorFixedContainer.appendChild(interiorNavMobile);
			}
		}
		
		if (mobileNavContent && mobileNavContent.innerHTML.trim() !== '') {
			const mobileNavContentContainer = document.createElement('div');
			mobileNavContentContainer.classList.add('int-nav-mobile-content-container');
			mobileNavContentContainer.appendChild(mobileNavContent);
			interiorMobileContainer.appendChild(mobileNavContentContainer);

			mobileNavContent.classList.remove('d-none');
		}
		
		if( trigger ) {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				if( e.currentTarget.classList.contains('active') ) {
					e.currentTarget.classList.remove('active');
					interiorMobileContainer.classList.remove('active');
					interiorNavMobile.style.height = "0px";
				} else {
					e.currentTarget.classList.add('active');
					interiorMobileContainer.classList.add('active');
					interiorNavMobile.style.height = (interiorMobileContainer.getBoundingClientRect().height + 20) + "px";
				}
			});
		}
		
	}

}
